import { render, staticRenderFns } from "./DatosCapital.vue?vue&type=template&id=d5f45420&scoped=true"
import script from "./DatosCapital.vue?vue&type=script&lang=js"
export * from "./DatosCapital.vue?vue&type=script&lang=js"
import style0 from "./DatosCapital.vue?vue&type=style&index=0&id=d5f45420&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f45420",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d5f45420')) {
      api.createRecord('d5f45420', component.options)
    } else {
      api.reload('d5f45420', component.options)
    }
    module.hot.accept("./DatosCapital.vue?vue&type=template&id=d5f45420&scoped=true", function () {
      api.rerender('d5f45420', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/constitucion/infoBase/DatosCapital.vue"
export default component.exports